import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReportTable from "../../../components/report/report-table";
import ScoreView from "../../../components/UI/ScoreView";
import {
  OverallSchoolReportService,
  SchoolReportSubTopicWiseService,
} from "../../../services/reports";
import * as actions from "../../../store/actions";
import * as configActions from "../../../store/config/actions";
import Notation from "../../../components/report/notation";
import { handleCompPerformance } from "../../../helpers";
import { TEACHER } from "../../../constants";
import { textIdentifier } from "../../../textIdentifier";

export default function SchoolOverallReport() {
  const { userType, userData } = useSelector((state) => state.auth);
  const { selectedCompetition, selectedSchool,lang } = useSelector(
    (state) => state.main
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [values, setValues] = useState({});
  const [isFetching, setIsFetching] = useState(true);

  const fetchReportsData = async () => {
    try {
      // overall API
      let overallRes = await OverallSchoolReportService(
        selectedCompetition.id,
        selectedSchool.id
      );

      overallRes = overallRes.data;

      // subTopic API
      let subTopicRes = await SchoolReportSubTopicWiseService(
        selectedCompetition.id,
        selectedSchool.id
      );

      subTopicRes = subTopicRes.data;

      //  filtering data
      // const subTopicFilteredValues = subTopicRes.map((item) => {
      //   const { accuracy, proficiency, marks } = item;
      //   item.proficiency_status = handleCompPerformance(
      //     proficiency,
      //     selectedCompetition.proficiency
      //   );
      //   item.accuracy_status = handleCompPerformance(
      //     accuracy,
      //     selectedCompetition.accuracy
      //   );
      //   item.marks_status = handleCompPerformance(
      //     marks,
      //     selectedCompetition.marks
      //   );
      //   return item;
      // });

      dispatch(
        actions.selectSchool(
          Object.assign(selectedSchool, {
            percentile: overallRes.percentile,
            accuracy: overallRes.accuracy,
            proficiency: overallRes.proficiency,
            marks: overallRes.marks,
            subTopicData: subTopicRes,
            hide_skills: overallRes.hide_skills
          })
        )
      );

      // managing user role
      if (userType === TEACHER) {
        navigate(
          `/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes`
        );
      } else {
        //  filtering overall report data
        const { accuracy, proficiency, marks } = overallRes;
        overallRes.proficiency_status = handleCompPerformance(
          proficiency,
          selectedCompetition.proficiency
        );
        overallRes.accuracy_status = handleCompPerformance(
          accuracy,
          selectedCompetition.accuracy
        );
        overallRes.marks_status = handleCompPerformance(
          marks,
          selectedCompetition.marks
        );
        setValues(overallRes);
      }
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool) {
      navigate("/");
    } else {
      fetchReportsData();
    }
  }, []);

  if (isFetching) {
    return null;
  }

  if (!values && !isFetching) {
    return <p>{textIdentifier["no-data-found"][lang]}</p>;
  }

  return (
    <div className="cr-card">
      <div className="row gx-0">
        <div className="col-4">
          {!selectedCompetition.hide_rank && <p>
            {textIdentifier["school-rank"][lang]}: {values.school_rank_in_competition}/{values.schools_in_competition}
          </p>}
        </div>
        <div className="col-6">
          <p>{textIdentifier["school-percentile"][lang]}: {selectedSchool?.percentile}%</p>
        </div>
      </div>
      <ReportTable
        data={[
          [
            `${parseFloat(values.proficiency).toFixed(2)}%`,
            `${parseFloat(values.accuracy).toFixed(2)}%`,
            parseFloat(
              values.easy_question_count +
                values.medium_question_count +
                values.hard_question_count
            ).toFixed(2),
            parseFloat(values.marks).toFixed(2),
          ],
          [
            <ScoreView
              content={textIdentifier["overall-proficiency"][lang]+` ${parseFloat(
                selectedCompetition.proficiency
              ).toFixed(2)}%`}
            >
              <div>
                <Notation status={values.proficiency_status} />
              </div>
            </ScoreView>,
            <ScoreView
              content={textIdentifier["overall-accuracy"][lang]+` ${parseFloat(
                selectedCompetition.accuracy
              ).toFixed(2)}%`}
            >
              <div>
                <Notation status={values.accuracy_status} />
              </div>
            </ScoreView>,
            `(E${parseFloat(values.easy_question_count).toFixed(
              2
            )}, M${parseFloat(values.medium_question_count).toFixed(
              2
            )}, H${parseFloat(values.hard_question_count).toFixed(2)})`,
            <ScoreView
              content={textIdentifier["overall-marks"][lang]+` ${parseFloat(
                selectedCompetition.marks
              ).toFixed(2)}`}
            >
              <div>
                <Notation status={values.proficiency_status} />
              </div>
            </ScoreView>,
          ],
        ]}
        headers={[[textIdentifier["proficiency"][lang], textIdentifier["accuracy"][lang], textIdentifier["question-count"][lang], textIdentifier["marks"][lang]]]}
      />
    </div>
  );
}
